export enum ProductRegion {
  NA = "NORTH AMERICA",
  EMEA = "EMEA",
  ASIA = "ASIA",
  GLOBAL = "GLOBAL",
}

export type ProductRegionOption = {
  label: string;
  value: ProductRegion;
};

export const productRegionOptions: ProductRegionOption[] = [
  {
    label: "Global",
    value: ProductRegion.GLOBAL,
  },
  {
    label: "Asia",
    value: ProductRegion.ASIA,
  },
  {
    label: "EMEA",
    value: ProductRegion.EMEA,
  },
  {
    label: "North America",
    value: ProductRegion.NA,
  },
];

export type GetProductParams = Partial<{
  items: string;
  name: string;
  page?: number;
  regions: ProductRegion;
  familyId: string;
  sortBy: string;
}>;
